import { action } from 'mobx';
import { API } from 'aws-amplify';
import { Bloodwork, BloodworkRange } from '../models';
import moment from 'moment';
const uuidv4 = require('uuid/v4');

export class BloodworkStore {
  @action async load(clientId?: string, limit?: number, lastCreateDate?: string): Promise<any> {
    //console.log('***************** loadBloodworks **********************************');
    const init = {
      queryStringParameters: {
          clientId,
          limit,
          lastCreateDate
      }
    };
    return new Promise<any>(
      (resolve) => API.get('restAPI', '/bloodwork/practitioner', init).then(data => {
        console.log(data);
        const bloodworkEntries = clientId ? data : data.Items;
        console.log(bloodworkEntries);
        let bloodworks = [];
        if (bloodworkEntries) {
          bloodworks = bloodworkEntries.map((bloodwork: Bloodwork) => {
            return new Bloodwork(bloodwork);
          });
        }

        data.bloodworks = bloodworks;
        data.Items = undefined;
        const results = clientId ? bloodworks : data;
        resolve(results);
      }
    ).catch((error) => {
      console.log(error);
      Promise.reject(error);
    }));
  }

  /**
   * The BloodworkRange table exactly as stored, row for row.
   *
   * NOT initialized. This used to run BloodworkRange.bloodworkRangesFrom() on
   * the response before resolving, and that call is now the entry store's, for
   * one reason: init() derives every optimal and alarm bound the row does not
   * carry, and it writes them onto the row. Once that has happened nothing can
   * tell an authored optimal from a derived one, and nothing can apply a
   * practitioner's own numbers underneath the derivation. My Ranges needs
   * both, so the stored rows have to survive somewhere, and the fetch is the
   * one place they exist before anything touches them.
   *
   * `reject` is wired up deliberately. The catch used to call a FLOATING
   * `Promise.reject(error)`, which settled nothing and raised an unhandled
   * rejection — so on a failed request this promise never resolved, the
   * caller's error handler never ran, and the busy spinner stayed up for
   * good. Rejecting properly lets the entry store fall back to [].
   */
  async loadBloodworkRanges(): Promise<BloodworkRange[]> {
    return new Promise<BloodworkRange[]>(
      (resolve, reject) => API.get('restAPI', '/bloodworkRange', {}).then(bloodworkRanges => {
        resolve(bloodworkRanges);
      }
    ).catch((error) => {
      console.error(error);
      reject(error);
    }));
  }

  async saveBloodwork(bloodwork: Bloodwork): Promise<Bloodwork> {
    const isNew = bloodwork.isNew();
    const currentDate = moment().toISOString(true);
    if (isNew) {
      bloodwork.id = uuidv4();
      bloodwork.createDate = currentDate;
    } 
    bloodwork.lastModifiedDate = currentDate;

    let requestParams = {
      body : bloodwork
    };

    return new Promise<Bloodwork>(
      (resolve, reject) => API.post('restAPI', '/bloodwork/practitioner', requestParams).then(response => {
        console.log(response);
        const savedBloodwork: Bloodwork = new Bloodwork(response);
        resolve(savedBloodwork);
      }).catch((error) => {
        console.error(error);
        if (isNew) {
          bloodwork.id = undefined;
          bloodwork.createDate = undefined;
          bloodwork.lastModifiedDate = undefined;
        }
        reject(error);
      }));
  }

  async deleteBloodwork(bloodwork: Bloodwork): Promise<any> {
    const init = {
      queryStringParameters: bloodwork.key()
    };
    console.log(init);
    return await API.del('restAPI', '/bloodwork', init);
  }
}